module.exports = __webpack_public_path__ + "cebce8df57cddbd0255850f2ffdbef44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/time-blue.png
// module id = 1886
// module chunks = 1